import appData from '@/helpers/app-data'

const state = {
  userData: appData.get('user'),
  pendingLogin: false,
  error: null,
  afterAction: null
}

const getters = {
  isLoggedIn: state => {
    return !!state.userData
  }
}

const mutations = {
  AUTHENTICATE (state) {
    state.pendingLogin = true
  },
  LOGIN (state, payload) {
    state.userData = payload
    state.pendingLogin = false
  },
  LOGOUT (state) {
    state.userData = null
  },
  CANCEL_LOGIN (state) {
    state.pendingLogin = false
    state.afterAction = null
  },
  SET_ACTION (state, action) {
    state.afterAction = action
  }
}

const actions = {
  // If an action is provided it is dispatched immediately after the user is authenticated
  authenticate ({state, commit, dispatch}, afterAction) {
    // If logged in, just dispatch the action
    if (state.userData) {
      dispatch(afterAction.action, afterAction.payload, { root: true })
    } else {
      if (dispatch) {
        commit('SET_ACTION', afterAction)
      }
      commit('AUTHENTICATE')
    }
  },
  login ({commit, state, dispatch}, user) {
    Promise.all([
      dispatch('folders/getFolders', null, { root: true }),
      dispatch('recommendations/getRemaining', null, { root: true })
    ]).then(() => {
      commit('LOGIN', user)
    })
    if (state.afterAction) {
      dispatch(state.afterAction.action, state.afterAction.payload, { root: true })
      commit('SET_ACTION', null)
    }
  },
  logout ({commit}) {
    commit('LOGOUT')
  },
  cancelLogin ({commit}) {
    commit('CANCEL_LOGIN')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./frontend/src/store/modules/user/index.js